var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 pb-3"},[_c('object-grid',{staticClass:"h-100",attrs:{"model-class":"CompanyLocation","flow-subtype":"","grid-max-height":"100%","colStateLocalStorageKey":'vendorProfileLocations',"fixedFilterKwargs":_vm.fixedFilterKwargs,"excludeFields":_vm.excludeFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }